export default {
  // UPDATE ACCOUNT HOLD
  "update-account-hold_page-title_active": "Are you sure you want to put this account on hold?",
  "update-account-hold_page-description_active": "Putting the account on hold will suspend all activity until the hold is removed. This includes any pending items.",
  "update-account-hold_page-title_inactive": "Are you sure you want to release the hold on this account?",
  "update-account-hold_page-description_inactive": "Curabitur blandit tempus porttitor.",
  "___update-account-hold_action_cancel": "",
  "update-account-hold_action_confirm-set-hold": "Set Hold",
  "update-account-hold_action_confirm-release-hold": "Release Hold",
  "___update-account-hold_action_done": "",
  "___update-account-hold_text_error-message_default": "",
  "___update-account-hold_title_confirm-close": "",
  "___update-account-hold_text_confirm-close": "",
  "___update-account-hold_action_confirm-close_cancel": "",
  "___update-account-hold_action_confirm-close_confirm": "",
  "___update-account-hold_text_loading-message": "",
  "update-account-hold_text_refresh-data-error-message": "Your account hold has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE PLAN TYPE
  "update-plan-type_page-title": "Change HSA Type",
  "update-plan-type_page-description": "",
  "___update-plan-type_action_cancel": "",
  "___update-plan-type_action_confirm": "",
  "___update-plan-type_action_done": "",
  "___update-plan-type_text_error-message_default": "",
  "___update-plan-type_title_confirm-close": "",
  "___update-plan-type_text_confirm-close": "",
  "___update-plan-type_action_confirm-close_cancel": "",
  "___update-plan-type_action_confirm-close_confirm": "",
  "___update-plan-type_text_loading-message": "",
  "___update-plan-type_action_submit": "",
  "update-plan-type_form-label_plan-type": "Select Type",
  "update-plan-type_form-terms-review": "Please review and agree to the terms and conditions for changing your Health Savings Account type.",
  "update-plan-type_form-label_terms-and-conditions-read": "I have read and agree to the Terms and Conditions",
  "update-plan-type_form-label_terms-and-conditions": "I understand any changes to my HSA type will change my current fees and interest rates. I also understand the new HSA type will not be effective until the first of the following month.",
  "update-plan-type_form-label_terms-and-conditions-non-standard": "I understand that I am changing from a legacy HSA type and I will not be available to return to this type in the future. I understand any changes to my HSA type will change my current fees and interest rates. I also understand the new HSA type will not be effective until the first of the following month.",
  "___update-plan-type_form-error_plan-type_required": "",
  "update-plan-type_form-error_terms-and-conditions_required": "Both Terms & Conditions boxes must be checked",
  "update-plan-type_text_refresh-data-error-message": "Your HSA type has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // UPDATE COVERAGE TIER
  "update-coverage-tier_page-title": "Change Coverage",
  "update-coverage-tier_page-description": "This will change the type of health coverage for this account.",
  "___update-coverage-tier_action_cancel": "",
  "___update-coverage-tier_action_confirm": "",
  "___update-coverage-tier_action_done": "",
  "___update-coverage-tier_text_error-message_default": "",
  "___update-coverage-tier_title_confirm-close": "",
  "___update-coverage-tier_text_confirm-close": "",
  "___update-coverage-tier_action_confirm-close_cancel": "",
  "___update-coverage-tier_action_confirm-close_confirm": "",
  "___update-coverage-tier_text_loading-message": "",
  "___update-coverage-tier_action_submit": "",
  "update-coverage-tier_form-label_coverage-tier": "Select Coverage Type",
  "___update-coverage-tier_form-error_coverage-tier_required": "",
  "___update-coverage-tier_form-error_terms-and-conditions_required": "",
  "update-coverage-tier_text_refresh-data-error-message": "Your coverage has been updated but we were unable to refresh the data on the screen. Please refresh the page.",
};